<template>
  <table>
    <tbody>
      <tr v-for="(tax, index) of visibleTaxes" :key="index">
        <td>
          <translate
            tag="span"
            v-if="tax.isInclusive"
            :tt="{ type: tax.type, rate: tax.rate }"
            >Includes {type} ({rate})</translate
          >
          <translate tag="span" v-else :tt="{ type: tax.type, rate: tax.rate }"
            >Plus {type} ({rate})</translate
          >
        </td>
        <td class="price">
          <pu-price :price="tax.amount" :display-original-price="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PricedTax } from '../../schema'

@Component
class AdditionalTaxes extends Vue {
  @Prop({ required: true })
  taxes: PricedTax[]

  get visibleTaxes(): PricedTax[] {
    return this.taxes.filter((tax) => !tax.isHidden)
  }
}

export default toNative(AdditionalTaxes)
</script>
<style scoped>
td.price {
  text-align: right;
  white-space: nowrap;
  padding-left: 0.5em;
}
</style>
